import http from '../../shared/http.js';
import { notifyError, notifySuccess } from '../../shared/notify.js';

// Arrow keys step through a radio group one entry at a time and fire `change`
// for every step, so a single keyboard sweep across ten themes would otherwise
// spend a tenth of the API rate limit.
const SAVE_DELAY_MS = 400;

export function initTheme() {
  const form = document.getElementById('theme-form');
  if (!form) return;

  // daisyUI's .theme-controller repaints the page through CSS the instant a
  // radio is checked, so this module only has to persist the choice. No loading
  // overlay for the same reason: blanking the screen over a change the user can
  // already see would be worse than the request being invisible.
  let persisted = form.querySelector('input[name="theme"]:checked')?.value;
  let timer;

  const save = async (chosen) => {
    try {
      await http.patch('/users/me/theme', { theme: chosen });
      persisted = chosen;
      notifySuccess('Design gespeichert.');
    } catch (err) {
      // Nothing was stored, so put the page back rather than leave it showing a
      // theme the server rejected. Re-checking the previous radio reverts the
      // colours too, because the CSS follows :checked - that is the payoff of
      // doing the preview in CSS instead of by swapping data-theme in JS.
      const previous = form.querySelector(`input[name="theme"][value="${persisted}"]`);
      if (previous) previous.checked = true;
      notifyError(err.response?.data?.message || 'Design konnte nicht gespeichert werden.');
    }
  };

  form.addEventListener('change', (event) => {
    if (event.target.name !== 'theme') return;
    const chosen = event.target.value;

    window.clearTimeout(timer);
    timer = window.setTimeout(() => save(chosen), SAVE_DELAY_MS);
  });
}
